import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/r2.svg'


const _hoisted_1 = { class: "home flex flex-row pl-16 md:pl-[200px]" }
const _hoisted_2 = { class: "text-white flex-col flex p-5 md:p-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-[26px]" }, "Account", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-col flex md:flex-row justify-start" }, null, -1)
const _hoisted_5 = { class: "text-cool text-[16px] mt-5" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-cool text-[16px] mt-1" }
const _hoisted_9 = { class: "text-cool text-[16px] mt-1" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5",
  src: _imports_0
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-[14px]" }, "Buy now", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "text-[14px] text-cool mt-5"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "max-w-[500px]" }, " At the moment we can't provide free tier, due huge computations costs on top GPU servers. For every user we train dedicated neural network. ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-[14px] text-cool mt-5 font-medium max-w-[500px]" }, " We might consider make it for free for bloggers and influencers in exchange for public link share of our service. ", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "max-w-[500px]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Menu, { type: "account" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createTextVNode(" Type : "),
        (!_ctx.paid)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Free user"))
          : _createCommentVNode("", true),
        (_ctx.paid)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Paid user"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, " Prompts : " + _toDisplayString(_ctx.prompts), 1),
      _createElementVNode("div", _hoisted_9, " Email : " + _toDisplayString(_ctx.email), 1),
      (!_ctx.paid)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.g_link,
            target: "_blank",
            class: "max-w-[200px] mt-5 max-h-[53px] cursor-pointer bg-blue-500 my_buy justify-center transition-all flex-row flex font-line font-normal hover:bg-blue-600 text-white py-4 px-8 rounded-xl"
          }, _hoisted_13, 8, _hoisted_10))
        : _createCommentVNode("", true),
      (!_ctx.paid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
        : _createCommentVNode("", true),
      (_ctx.paid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Training & avatars generation might take up to 14 hours. Contact support if you have any other questions. "))
        : _createCommentVNode("", true)
    ])
  ]))
}